import { render, staticRenderFns } from "./StarList.vue?vue&type=template&id=29c3b47f&scoped=true&"
import script from "./StarList.vue?vue&type=script&lang=js&"
export * from "./StarList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c3b47f",
  null
  
)

export default component.exports